const leaflets = {
    "migross": {
        "config": {
            "primary-color": "rgb(213, 19, 23)",
            "secondary-color": "rgb(0, 99, 175)",
            "tertiary-color": "rgb(99, 44, 56)",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "clientIcon": require("assets/images/migross_logo.jpg"),
            "serverPath": "migross.volantinointerattivo.net/",
            "pdfPath": "/media/pdf/volantino.pdf",
            "shareFlyerTitle": "Dai uno sguardo al nuovo volantino di Migross!",
            "shareFlyerURL": "https://migross.volantinointerattivo.net",
            "shareProductSentence": "Guarda questa fantastica offerta!",
            "ogTitleMeta": "Volantino Interattivo Migross",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo volantino.",
            "ogImageMeta": "https://migross.volantinointerattivo.net/media/images/migross_fb.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": true, 
            "ga_tracking_id": "UA-152069090-27",
            "release_id": "1",
            "send_grocery_list_to_market": true,
            "grocery_list_min_value": 0.1,
            "client_id": 21,
            "signboard_id": 38,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": true,
            "category_banner": "",
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "type": "leaflet"

        },
        "leaflet": {
            "name": "Migross_Demo",
            "code": "456",
            "id_campaign": "456",
            "index": {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/indice_waNsv1s.png",
            "links": [
            {
            "page": 2,
            "blueprint": {
            "top": 29.128978486852212,
            "left": 12.452324973876697,
            "width": 78.10170488746189,
            "height": 6.388512190339712
            }
            },
            {
            "page": 4,
            "blueprint": {
            "top": 35.659807172074586,
            "left": 12.251900584221882,
            "width": 78.10170488746189,
            "height": 6.388512190339712
            }
            },
            {
            "page": 5,
            "blueprint": {
            "top": 42.103555526612695,
            "left": 12.752958805957183,
            "width": 78.10170488746189,
            "height": 6.388512190339712
            }
            },
            {
            "page": 11,
            "blueprint": {
            "top": 48.19899212505264,
            "left": 12.251900584221882,
            "width": 78.10170488746189,
            "height": 6.388512190339712
            }
            },
            {
            "page": 12,
            "blueprint": {
            "top": 54.55566254056621,
            "left": 12.051481699370537,
            "width": 78.10170488746189,
            "height": 6.388512190339712
            }
            },
            {
            "page": 14,
            "blueprint": {
            "top": 60.825255017055234,
            "left": 12.45233047868017,
            "width": 78.10170488746189,
            "height": 6.388512190339712
            }
            },
            {
            "page": 16,
            "blueprint": {
            "top": 67.00776955451973,
            "left": 12.45233047868017,
            "width": 78.10170488746189,
            "height": 6.388512190339712
            }
            }
            ]
            },
            "categories": [
            {
            "category_name": "Ortofrutta",
            "subcategories": [
            "Frutta",
            "Verdura"
            ]
            },
            {
            "category_name": "Macelleria",
            "subcategories": [
            "Bovino",
            "Suino",
            "Avicoli",
            "Altro"
            ]
            },
            {
            "category_name": "Gastronomia",
            "subcategories": [
            "Salumi",
            "Formaggi",
            "Piatti Pronti"
            ]
            },
            {
            "category_name": "Self Service",
            "subcategories": [
            "Yogurt",
            "Snack",
            "Formaggi",
            "Pasta",
            "Vegetali",
            "Ittico",
            "Salumi",
            "Latte"
            ]
            },
            {
            "category_name": "Alimentari",
            "subcategories": [
            "Dispensa",
            "Colazione",
            "Snack Dolci"
            ]
            }
            ],
            "pages": [
            {
            "number": 1,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_1_hvzkUrK.jpg",
            "products": []
            },
            {
            "number": 2,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_2_b0elcA2.jpg",
            "products": [
            {
            "item_id": "cstm48627029",
            "field1": "Pesche gialle",
            "field2": "origine Italia",
            "field3": "",
            "field4": "",
            "description": "Pesche gialle origine Italia",
            "grammage": null,
            "price": "1.99",
            "price_label": "€ 1,99 al Kg",
            "equivalence": 1000,
            "quantity_step": 500,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Ortofrutta",
            "subcategory": "Frutta",
            "blueprint": {
            "top": 15.919237012987013,
            "left": 4.119791054725647,
            "width": 46.64324140548706,
            "height": 25.800414333095798
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_gk3XNuN_GRqiqFZ.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm14869856",
            "field1": "Albicocche sfuse",
            "field2": "origine Italia",
            "field3": "",
            "field4": "",
            "description": "Albicocche sfuse origine Italia",
            "grammage": null,
            "price": "2.49",
            "price_label": "€ 2,49 al Kg",
            "equivalence": 1000,
            "quantity_step": 500,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Ortofrutta",
            "subcategory": "Frutta",
            "blueprint": {
            "top": 15.919237012987013,
            "left": 50.763032460212685,
            "width": 44.82551777362825,
            "height": 25.800414333095798
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_qXIPtfB_7PjYAcF.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm92776337",
            "field1": "Pomodoro tondo insalataro",
            "field2": "origine Italia",
            "field3": "",
            "field4": "",
            "description": "Pomodoro tondo insalataro origine Italia",
            "grammage": null,
            "price": "1.49",
            "price_label": "€ 1,49 al Kg",
            "equivalence": 1000,
            "quantity_step": 500,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Ortofrutta",
            "subcategory": "Frutta",
            "blueprint": {
            "top": 41.7872928334521,
            "left": 4.944017148017872,
            "width": 44.82551777362825,
            "height": 25.800414333095798
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_FMv674G_F44M3fl.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm77624201",
            "field1": "Angurie",
            "field2": "",
            "field3": "",
            "field4": "",
            "description": "Angurie",
            "grammage": null,
            "price": "0.49",
            "price_label": "€ 0,49 al Kg",
            "equivalence": 1000,
            "quantity_step": 500,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Ortofrutta",
            "subcategory": "Frutta",
            "blueprint": {
            "top": 41.61368119252192,
            "left": 49.660161757469155,
            "width": 44.82551777362825,
            "height": 25.800414333095798
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_OJDDh1j_pJnlkk9.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm11857355",
            "field1": "Melanzane tonde",
            "field2": "origine Italia",
            "field3": "",
            "field4": "",
            "description": "Melanzane tonde origine Italia",
            "grammage": null,
            "price": "1.19",
            "price_label": "€ 1,19 al Kg",
            "equivalence": 1000,
            "quantity_step": 500,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Ortofrutta",
            "subcategory": "Verdura",
            "blueprint": {
            "top": 67.82896029484736,
            "left": 6.347661757469167,
            "width": 44.82551777362825,
            "height": 25.800414333095798
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_WUL39S0_n1uQVdN.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            },
            {
            "type": "hat-chef",
            "title": "Pasta con le melanzane",
            "data": {
            "ingredients": "Sedanini Rigati 320 g, Melanzane 350 g, Pomodorini ciliegino 250 g, Basilico qualche foglia, Cipollotto fresco 100 g, Sale fino q.b., Pepe nero q.b., Olio extravergine d'oliva 30 g",
            "recipe": "Per preparare la pasta con le melanzane per prima cosa occupatevi di quest'ultime. Lavatele, spuntatele e tagliatele prima a fette e poi a cubetti di circa 1 cm. Quindi trasferitele in un colino, salatele leggermente e posizionate al di sopra di esse un piattino con un peso e lasciatele spurgare per un paio d'ore. Quando le melanzane avranno eliminato tutta l'acqua di vegetazione, iniziate a tagliare il cipollotto prima a metà e poi a fettine piuttosto sottili. Versate l'olio in un tegame, lasciatelo scaldare e unite il cipollotto. Una volta che sarà ben dorato aggiungete le melanzane, salate, pepate e lasciatte cuocere circa 15 minuti. Nel frattempo lavate i pomodorini e tagliateli in 4 spicchi e aggiungeteli alle melanzane solo quando queste risulteranno tenere e cotte. Aggiustate di sale e di pepe e lasciate cuocere per altri 4-5 minuti. Nel frattempo cuocete la pasta in abbondante acqua bollente, salata a piacere; una volta al dente scolatela e versatela direttamente nel tegame con le melanzane. Saltate la vostra pasta con melanzane per qualche minuto aggiungendo le foglioline di basilico, ora non vi resta che impiattarla!\n(Fonte: ricette.giallozafferano.it)",
            "img": [
            "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/images/Pasta_con_le_melanzane.jpg"
            ]
            }
            }
            ]
            },
            {
            "item_id": "cstm03940146",
            "field1": "Insalata iceberg",
            "field2": "350 g",
            "field3": "",
            "field4": "",
            "description": "Insalata iceberg 350 g",
            "grammage": null,
            "price": "0.99",
            "price_label": "€ 0,99",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Ortofrutta",
            "subcategory": "Verdura",
            "blueprint": {
            "top": 67.82896029484736,
            "left": 51.56511273384093,
            "width": 44.82551777362825,
            "height": 25.800414333095798
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_ZkOLFCP_TCQ1leC.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            }
            ]
            },
            {
            "number": 3,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_3_fvwZjMS.jpg",
            "products": [
            {
            "item_id": "cstm21732998",
            "field1": "Macinato",
            "field2": "sceltissimo di scottona",
            "field3": "",
            "field4": "€ 10,90",
            "description": "Macinato sceltissimo di scottona € 10,90",
            "grammage": null,
            "price": "8.99",
            "price_label": "€ 8,99 al Kg",
            "equivalence": 1000,
            "quantity_step": 500,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Macelleria",
            "subcategory": "Bovino",
            "blueprint": {
            "top": 15.91922986042964,
            "left": 4.242189335823048,
            "width": 44.82551777362825,
            "height": 25.800414333095798
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_cZ0A5XL_99vIY0Y.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm88673683",
            "field1": "Coppa di suino",
            "field2": "a fette senza osso",
            "field3": "Confezione famiglia ",
            "field4": "€ 6,79",
            "description": "Coppa di suino a fette senza osso Confezione famiglia  € 6,79",
            "grammage": null,
            "price": "5.99",
            "price_label": "€ 5,99 al Kg",
            "equivalence": 1000,
            "quantity_step": 500,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Macelleria",
            "subcategory": "Suino",
            "blueprint": {
            "top": 15.832424039964552,
            "left": 50.66276898384092,
            "width": 44.82551777362825,
            "height": 25.800414333095798
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_TF9Oqcp_mpwGOzv.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm26220597",
            "field1": "Coscette di pollo",
            "field2": "aromatizzate",
            "field3": "",
            "field4": "€ 6,90",
            "description": "Coscette di pollo aromatizzate € 6,90",
            "grammage": null,
            "price": "4.50",
            "price_label": "€ 4,50 al Kg",
            "equivalence": 1000,
            "quantity_step": 500,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Macelleria",
            "subcategory": "Avicoli",
            "blueprint": {
            "top": 41.78729521763789,
            "left": 5.7239626169204705,
            "width": 48.046875,
            "height": 25.974025974025974
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_5EvoRPc_L05P9r1.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm26189223",
            "field1": "Amadori",
            "field2": "le birbe",
            "field3": "300 g",
            "field4": "€ 3,99",
            "description": "Amadori le birbe 300 g € 3,99",
            "grammage": null,
            "price": "2.39",
            "price_label": "€ 2,39",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Macelleria",
            "subcategory": "Altro",
            "blueprint": {
            "top": 41.78729521763789,
            "left": 53.770837616920474,
            "width": 40.88411335945129,
            "height": 25.974025974025974
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_0pVLnGE_wL7AbzY.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            },
            {
            "type": "world",
            "title": "",
            "data": "https://www.amadori.it/prodotti/impanati/bocconcini-di-pollo-classici"
            }
            ]
            },
            {
            "item_id": "cstm75209231",
            "field1": "Amadori",
            "field2": "hamburger classico/delicato/erbette",
            "field3": "204 g",
            "field4": "€ 2,89",
            "description": "Amadori hamburger classico/delicato/erbette 204 g € 2,89",
            "grammage": 204,
            "price": "0.00",
            "price_label": "€ 1,73",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [
            "Classico",
            "Delicato",
            "Erbette"
            ],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Macelleria",
            "subcategory": "Altro",
            "blueprint": {
            "top": 67.74215685856807,
            "left": 5.946613359451293,
            "width": 87.20442953109742,
            "height": 25.974025974025974
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_W9pY9fr_oZsmyGE.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            }
            ]
            },
            {
            "number": 4,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_4_2XZsFdv.jpg",
            "products": [
            {
            "item_id": "cstm10466366",
            "field1": "Speck cadore",
            "field2": "Unterberger",
            "field3": "",
            "field4": "€ 15,90",
            "description": "Speck cadore Unterberger € 15,90",
            "grammage": null,
            "price": "13.90",
            "price_label": "€ 13,90 al Kg",
            "equivalence": 1000,
            "quantity_step": 100,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Gastronomia",
            "subcategory": "Salumi",
            "blueprint": {
            "top": 15.955946445465088,
            "left": 4.202920937538147,
            "width": 27.170575976371765,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_V0uTmsF_8OeB1ug.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm84147142",
            "field1": "Villani",
            "field2": "cotto alla brace",
            "field3": "",
            "field4": "€ 17,90",
            "description": "Villani cotto alla brace € 17,90",
            "grammage": null,
            "price": "13.90",
            "price_label": "€ 13,90 al Kg",
            "equivalence": 1000,
            "quantity_step": 100,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Gastronomia",
            "subcategory": "Salumi",
            "blueprint": {
            "top": 15.955946445465088,
            "left": 31.37349691390991,
            "width": 33.787756133079526,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_SOOvxNh_leFotDi.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm44797777",
            "field1": "Migross",
            "field2": "prosciutto di Parma DOP",
            "field3": "stagionatura min 18 mesi ",
            "field4": "€ 23,90",
            "description": "Migross prosciutto di Parma DOP stagionatura min 18 mesi  € 23,90",
            "grammage": null,
            "price": "19.90",
            "price_label": "€ 19,90 al Kg",
            "equivalence": 1000,
            "quantity_step": 100,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Gastronomia",
            "subcategory": "Salumi",
            "blueprint": {
            "top": 15.955946445465088,
            "left": 62.253705859184265,
            "width": 33.186197304725646,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_xYkvDms_rtIbux3.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm10202539",
            "field1": "Prmigiano reggiano DOp",
            "field2": "24 medi",
            "field3": "",
            "field4": "14,90",
            "description": "Prmigiano reggiano DOp 24 medi 14,90",
            "grammage": null,
            "price": "10.90",
            "price_label": "€ 10,90 al Kg",
            "equivalence": 1000,
            "quantity_step": 100,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Gastronomia",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 41.82400107383728,
            "left": 3.609375,
            "width": 28.57422058582306,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_eK14DUh_cfkVUF1.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm38604290",
            "field1": "Emmental francese",
            "field2": "",
            "field3": "",
            "field4": "€ 8,90",
            "description": "Emmental francese € 8,90",
            "grammage": null,
            "price": "5.90",
            "price_label": "€ 5,90 al Kg",
            "equivalence": 1000,
            "quantity_step": 100,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Gastronomia",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 41.82400107383728,
            "left": 31.080730390548705,
            "width": 33.486982226371765,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_4BSRUIA_4qxNjCW.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm19415708",
            "field1": "Sqacquerone",
            "field2": "",
            "field3": "",
            "field4": "€ 8,90",
            "description": "Sqacquerone € 8,90",
            "grammage": null,
            "price": "7.90",
            "price_label": "€ 7,90 al Kg",
            "equivalence": 1000,
            "quantity_step": 100,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Gastronomia",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 41.82400107383728,
            "left": 62.161455273628235,
            "width": 33.427094960212706,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_hfdFpW1_s1MH2Cg.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            },
            {
            "type": "hat-chef",
            "title": "Schiacciate con crema di squacquerone e culatello",
            "data": {
            "ingredients": "Schiacciate al forno 12, Squacquerone 200 g, Culatello 6 fette, Panna fresca liquida 50 ml, Pepe verde 1 cucchiaio, Aceto balsamico di Modena 2 cucchiai, Olio extravergine d'oliva 2 cucchiai, Sale fino q.b.",
            "recipe": "Per comporre le schiacciate con culatello e crema di squacquerone Iniziate preparando la crema di squacquerone al pepe verde: ponete in un mixer lo squacquerone, la panna fresca e i due cucchiai d’olio. Frullate fino ad amalgamare bene tutti gli ingredienti ottenendo una crema liscia ed omogenea. Schiacciate il pepe verde e aggiungetelo alla crema di squacquerone, infine aggiustate di sale e mescolate bene. Riempite una sac à poche con la punta dentellata con la crema di squacquerone al pepe verde e coprite le Schiacciate“La Bottega di Olivia&Marino”. Tagliate a metà il culatello e posatelo sulle Schiacciate, in ultimo concludete facendo colare su ogni stuzzichino qualche goccia di glassa di aceto balsamico di Modena.",
            "img": [
            "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/images/squacquerone.jpg"
            ]
            }
            }
            ]
            },
            {
            "item_id": "cstm84359830",
            "field1": "Sfogliata di verdure",
            "field2": "",
            "field3": "",
            "field4": "€ 10,90",
            "description": "Sfogliata di verdure € 10,90",
            "grammage": null,
            "price": "9.90",
            "price_label": "€ 9,90 al Kg",
            "equivalence": 1000,
            "quantity_step": 100,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Gastronomia",
            "subcategory": "Piatti Pronti",
            "blueprint": {
            "top": 67.77886271476746,
            "left": 4.311197304725647,
            "width": 27.210946679115295,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_VzyVlEG_jENypQj.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm77804586",
            "field1": "Riso venere",
            "field2": "verdure e gamberi",
            "field3": "",
            "field4": "€ 13,90",
            "description": "Riso venere verdure e gamberi € 13,90",
            "grammage": null,
            "price": "11.90",
            "price_label": "€ 11,90 al Kg",
            "equivalence": 1000,
            "quantity_step": 100,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Gastronomia",
            "subcategory": "Piatti Pronti",
            "blueprint": {
            "top": 67.77886271476746,
            "left": 31.52214398384094,
            "width": 33.74739093780518,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_AkwC49d_BVDblbw.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm92291760",
            "field1": "Insalata di mare",
            "field2": "",
            "field3": "",
            "field4": "€ 29,90",
            "description": "Insalata di mare € 29,90",
            "grammage": null,
            "price": "28.90",
            "price_label": "€ 28,90 al Kg",
            "equivalence": 1000,
            "quantity_step": 100,
            "grocery_label": "gr.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Gastronomia",
            "subcategory": "Piatti Pronti",
            "blueprint": {
            "top": 67.77886271476746,
            "left": 62.66276164054871,
            "width": 32.825536131858826,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_DcZ3b9x_W1ytSi4.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            }
            ]
            },
            {
            "number": 5,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_5_AvFgyiG.jpg",
            "products": [
            {
            "item_id": "cstm66587377",
            "field1": "Muller",
            "field2": "yogurt assortito",
            "field3": "x8 - 1000 g",
            "field4": "€ 3,30",
            "description": "Muller yogurt assortito x8 - 1000 g € 3,30",
            "grammage": null,
            "price": "1.98",
            "price_label": "€ 1,98",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [
            "Ciliegia",
            "Pesca e albicocca",
            "Fragola",
            "Cocco",
            "Nocciola",
            "Stracciatella",
            "Vaniglia naturale",
            "Pistacchio"
            ],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Yogurt",
            "blueprint": {
            "top": 8.924695253372192,
            "left": 5.714841914176942,
            "width": 29.31642460823059,
            "height": 22.048611640930176
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/125multip_9ZKZz1M.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/125multip_1_PspdNaU.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/125multip_2_ZS9UgCX.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/125multip_3_XJ05HIJ.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_kaNqpju_aZGajYE.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            },
            {
            "type": "play",
            "title": "",
            "data": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/video/MULLER_ANCOR_PIU_CREMOSO_GIUGNO2019.mp4"
            }
            ]
            },
            {
            "item_id": "cstm25984089",
            "field1": "Danone",
            "field2": "yogurt activia",
            "field3": "assortiti x4 - 500 g",
            "field4": "2,65",
            "description": "Danone yogurt activia assortiti x4 - 500 g 2,65",
            "grammage": null,
            "price": "1.85",
            "price_label": "€ 1,85",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Yogurt",
            "blueprint": {
            "top": 8.924695253372192,
            "left": 35.031266522407535,
            "width": 29.536440587043764,
            "height": 22.048611640930176
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/Frutta-Mirtillo__1__2z13DFX.jpg",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/Naturale_MGbsBsd.jpg",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_vO1fg25_6hvgZjj.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm01234550",
            "field1": "Migross",
            "field2": "tramezzini",
            "field3": "assortiti 140 g",
            "field4": "€ 6,78",
            "description": "Migross tramezzini assortiti 140 g € 6,78",
            "grammage": 140,
            "price": "0.95",
            "price_label": "€ 0,95",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Snack",
            "blueprint": {
            "top": 8.924695253372192,
            "left": 64.56770710945129,
            "width": 29.717473006248476,
            "height": 22.048611640930176
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_GOU3Oa3_PekWxyI.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm81520506",
            "field1": "Prealpi",
            "field2": "burro",
            "field3": "250 g",
            "field4": "€ 2,59",
            "description": "Prealpi burro 250 g € 2,59",
            "grammage": null,
            "price": "1.55",
            "price_label": "€ 1,55",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 31.233723163604736,
            "left": 5.213541054725647,
            "width": 29.717473006248476,
            "height": 20.659723281860348
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/Burro-Prealpi-rotolo-gr.250_HLwL0e6.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_zu2lzgl_U3b538C.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm21095394",
            "field1": "Vallelata",
            "field2": "stracchino cremoso",
            "field3": "200 g",
            "field4": "€ 2,79",
            "description": "Vallelata stracchino cremoso 200 g € 2,79",
            "grammage": 200,
            "price": "1.95",
            "price_label": "€ 1,95",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 31.233723163604736,
            "left": 34.93101406097412,
            "width": 29.536435079574584,
            "height": 20.659723281860348
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/stracchino_Di9rEfd.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_bTtBfBi_2fVEoP6.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm00299630",
            "field1": "Zorbas",
            "field2": "feta DOP",
            "field3": "200 g",
            "field4": "€ 2,59",
            "description": "Zorbas feta DOP 200 g € 2,59",
            "grammage": 200,
            "price": "1.55",
            "price_label": "€ 1,55",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 31.233723163604736,
            "left": 64.46744914054871,
            "width": 29.61720952987671,
            "height": 20.659723281860348
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/feta_sottovuoto_1lNe8PJ.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_JhIa3LI_d1Mela7.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm43009417",
            "field1": "Biraghi",
            "field2": "petali sottili",
            "field3": "80 g",
            "field4": "€ 1,98",
            "description": "Biraghi petali sottili 80 g € 1,98",
            "grammage": 80,
            "price": "1.18",
            "price_label": "€ 1,18",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 52.15386152267456,
            "left": 5.313799023628235,
            "width": 29.61720952987671,
            "height": 20.659723281860348
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/GRAN-BIRAGHI-PETALI-SOTTILI_2019-768x1023_km3YP3B.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_ctTbP44_KhV9IDb.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm45838799",
            "field1": "Philadelphia",
            "field2": "original",
            "field3": "150 g",
            "field4": "€ 1,79",
            "description": "Philadelphia original 150 g € 1,79",
            "grammage": 150,
            "price": "1.03",
            "price_label": "€ 1,03",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 52.15386152267456,
            "left": 34.931008553504945,
            "width": 29.636693048477174,
            "height": 20.659723281860348
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/85603_0UsefZG.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_d5QQYl9_56yGHAz.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm25884845",
            "field1": "Sottilette",
            "field2": "classiche",
            "field3": "400 g",
            "field4": "€ 2,59",
            "description": "Sottilette classiche 400 g € 2,59",
            "grammage": 400,
            "price": "2.29",
            "price_label": "€ 2,29",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 52.15386152267456,
            "left": 64.56770160198212,
            "width": 29.51695156097412,
            "height": 20.659723281860348
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/gamma_details_headerIMG_FeXIPUV.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_obG98aL_8g5Xk6r.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm55244649",
            "field1": "Migross",
            "field2": "parmigiano reggiano DOP",
            "field3": "grattugiato 100 g",
            "field4": "€ 1,99",
            "description": "Migross parmigiano reggiano DOP grattugiato 100 g € 1,99",
            "grammage": 100,
            "price": "1.39",
            "price_label": "€ 1,39",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 73.24761152267456,
            "left": 5.3137880086898805,
            "width": 29.51695156097412,
            "height": 20.659723281860348
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_GAwxUsp_5M8w7ZM.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm26991776",
            "field1": "Agriform",
            "field2": "grana padano DOP",
            "field3": "latte della Lessinia 200 g",
            "field4": "€ 3,39",
            "description": "Agriform grana padano DOP latte della Lessinia 200 g € 3,39",
            "grammage": 200,
            "price": "2.70",
            "price_label": "€ 2,70",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 73.24761152267456,
            "left": 34.830739569664004,
            "width": 29.837220001220704,
            "height": 20.659723281860348
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_MdH8BBG_2S4XhYR.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm74372490",
            "field1": "Buitoni",
            "field2": "pasta sfoglia",
            "field3": "rettangolare 230 g",
            "field4": "",
            "description": "Buitoni pasta sfoglia rettangolare 230 g",
            "grammage": null,
            "price": "0.00",
            "price_label": "",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": true,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Pasta",
            "blueprint": {
            "top": 73.24761152267456,
            "left": 64.6679595708847,
            "width": 29.917994451522826,
            "height": 20.659723281860348
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/IMMAGINO_IMMAGINO_EAN8000300254464_1_renditions_1500x1500_Oidg1KN.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_yU3U6lp_Fb7tOI6.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            }
            ]
            },
            {
            "number": 6,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_6_dO12RZU.jpg",
            "products": [
            {
            "item_id": "cstm00658056",
            "field1": "Caseificio pugliese",
            "field2": "fior di latte",
            "field3": "bomba di latte 400 g",
            "field4": "€ 4,49",
            "description": "Caseificio pugliese fior di latte bomba di latte 400 g € 4,49",
            "grammage": 400,
            "price": "2.69",
            "price_label": "€ 2,69",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 9.705944061279295,
            "left": 5.514314961433412,
            "width": 29.917994451522826,
            "height": 42.44791984558106
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_tNSE4cV_yVHO1iG.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm55745735",
            "field1": "Pintoni",
            "field2": "pasta fresca all'uovo",
            "field3": "fettuccibe Larghe/Medie 500 g",
            "field4": "€ 1,99",
            "description": "Pintoni pasta fresca all'uovo fettuccibe Larghe/Medie 500 g € 1,99",
            "grammage": 500,
            "price": "1.59",
            "price_label": "€ 1,59",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [
            "Fettuccine larghe",
            "Fettuccine medie"
            ],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Pasta",
            "blueprint": {
            "top": 9.705944061279295,
            "left": 35.432309412956236,
            "width": 29.63669855594635,
            "height": 21.527781486511227
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_G4GIMX9_y8FANWf.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            },
            {
            "type": "hat-chef",
            "title": "Fettuccine alla papalina",
            "data": {
            "ingredients": "Fettuccine all'uovo 250 g, Burro 50 g, Cipolle 50 g, Prosciutto crudo 100 g, Panna fresca liquida 200 g, Uova medie 3, Parmigiano Reggiano DOP da grattugiare 60 g, Pepe nero q.b., Sale fino q.b., Acqua a temperatura ambiente 1 mestolo",
            "recipe": "Per preparare le fettuccine alla papalina tagliate prima a fette e poi a listarelle il prosciutto crudo. Ponete sul fuoco una pentola antiaderente e fate sciogliere il burro a tocchetti. Lasciate appassire la cipolla tritata finemente per 8 minuti nel burro aggiungendo un mestolo di acqua a temperatura ambiente. Unite il prosciutto crudo precedentemente tagliato a listarelle e mescolate con una spatola da cucina, facendo cuocere per altri 2 minuti. Una volta pronto, spegnete e tenete da parte. Mettete sul fuoco una pentola con acqua salata e portate a bollore, quindi cuocete le fettuccine al dente per 3 minuti; nel frattempo rompete le uova in un recipiente e aggiungete la panna, e mescolate energicamente con le fruste. Unite il formaggio grattugiato, mischiate nuovamente, infine aggiustate di sale. Trascorso il tempo necessario, scolate le fettuccine e versatele direttamente nella padella con il condimento, facendole saltare per qualche istante per insaporire; spegnete il fuoco e aggiungete il composto a base di uova, distribuendolo in maniera omogena sulla pasta. Mischiate velocemente per amalgamare bene tutti gli ingredienti, quindi regolate di pepe: le vostre fettuccine alla papalina sono pronte per essere servite ben calde.\n(Fonte: ricette.giallozafferano.it)",
            "img": [
            "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/images/Fettuccine_alla_papalina.png"
            ]
            }
            }
            ]
            },
            {
            "item_id": "cstm08795388",
            "field1": "Rana",
            "field2": "sfogliavelo assortiti",
            "field3": "250 g",
            "field4": "€ 2,89",
            "description": "Rana sfogliavelo assortiti 250 g € 2,89",
            "grammage": 250,
            "price": "1.99",
            "price_label": "€ 1,99",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [
            "Prosciutto crudo",
            "Ricotta e spinaci",
            "Carne",
            "Speck e formaggio",
            "Brasato",
            "Parmigiana di melanzane",
            "Salmone",
            "Feta e olive kalamata",
            "Pecorino e prosciutto toscano DOP",
            "Gorgonzola DOP e passito",
            "Mozzarella e 'nduja"
            ],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Pasta",
            "blueprint": {
            "top": 9.705944061279295,
            "left": 65.06900796890258,
            "width": 31.121101093292236,
            "height": 21.527781486511227
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-brasato-250g---3D_LYb47gI.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-carne-250g---3D_NEVcTPK.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-crudo-250g---3D_zmOnAYJ.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-feta-e-olive-250g---3D_wMKwcXf.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-gorgonzola-dop-e-passito-250g---3D_2W7xIL5.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-mozzarella-nduja-250g---3D_7leCscL.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-parmigiana-di-melanzane-250g---3D_PPEwuoY.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-pecorino-e-prosciutto-Toscano-DOP-250g---3D_LhX3ENU.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-ricotta-spinaci-250g---3D_CzK2CW0.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-salmone-250g---3D_oM3DmUY.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/SFV-speck-e-formaggio-tirolese-250g---3D_ODC2g4c.png",
            "cropped": false
            },
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_aZzzVL6_nGKJDCu.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            },
            {
            "type": "play",
            "title": "",
            "data": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/video/Rana_sfogliavelo.mp4"
            }
            ]
            },
            {
            "item_id": "cstm06749259",
            "field1": "Migross",
            "field2": "mozzarelline",
            "field3": "150 g",
            "field4": "€ 1,49",
            "description": "Migross mozzarelline 150 g € 1,49",
            "grammage": 150,
            "price": "1.09",
            "price_label": "€ 1,09",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Formaggi",
            "blueprint": {
            "top": 31.233725547790527,
            "left": 35.43228187561035,
            "width": 29.636726093292236,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_xHsMKvf_3bsVPhp.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm52983183",
            "field1": "Viva la mamma ",
            "field2": "pesto con e senz'aglio",
            "field3": "90 g",
            "field4": "€ 1,29",
            "description": "Viva la mamma  pesto con e senz'aglio 90 g € 1,29",
            "grammage": null,
            "price": "0.77",
            "price_label": "€ 0,77",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [
            "Con aglio",
            "Senza aglio "
            ],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Vegetali",
            "blueprint": {
            "top": 31.233725547790527,
            "left": 65.06900796890258,
            "width": 30.01821937561035,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_jMsFqHu_urteTzq.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm05431795",
            "field1": "Kv nordic",
            "field2": "salmone norvegese",
            "field3": "affumicato 50 g",
            "field4": "€ 3,55",
            "description": "Kv nordic salmone norvegese affumicato 50 g € 3,55",
            "grammage": null,
            "price": "2.48",
            "price_label": "€ 2,48",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Ittico",
            "blueprint": {
            "top": 52.067058086395264,
            "left": 5.113283085823059,
            "width": 30.01821937561035,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_luV55Rt_lju2Ki6.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm69203378",
            "field1": "Negroni",
            "field2": "pancetta a cubetti",
            "field3": "dolce/affumicata 90 g",
            "field4": "€ 1,79",
            "description": "Negroni pancetta a cubetti dolce/affumicata 90 g € 1,79",
            "grammage": 90,
            "price": "1.07",
            "price_label": "€ 1,07",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [
            "Dolce",
            "Affumicata"
            ],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Salumi",
            "blueprint": {
            "top": 52.067058086395264,
            "left": 35.13150246143341,
            "width": 29.73699507713318,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_Q6fg1LS_Mxv2Uue.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm44089529",
            "field1": "Re di sapori",
            "field2": "mortadella Bologna IGP",
            "field3": "120 g",
            "field4": "€ 2,89",
            "description": "Re di sapori mortadella Bologna IGP 120 g € 2,89",
            "grammage": 120,
            "price": "1.99",
            "price_label": "€ 1,99",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Salumi",
            "blueprint": {
            "top": 52.067058086395264,
            "left": 64.86849753856659,
            "width": 29.41666054725647,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_J8edWSL_3ELXFiu.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm51422815",
            "field1": "Migross",
            "field2": "wurstel",
            "field3": "250 g",
            "field4": "€ 1,19",
            "description": "Migross wurstel 250 g € 1,19",
            "grammage": 250,
            "price": "0.83",
            "price_label": "€ 0,83",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Snack",
            "blueprint": {
            "top": 73.16080808639526,
            "left": 5.815105390548707,
            "width": 29.41666054725647,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_kD6w2km_shfsxvJ.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm75595971",
            "field1": "Casa Modena",
            "field2": "gran tenerone prosciutto cotto",
            "field3": "alta qualità 110 g",
            "field4": "€ 2,99",
            "description": "Casa Modena gran tenerone prosciutto cotto alta qualità 110 g € 2,99",
            "grammage": 110,
            "price": "1.79",
            "price_label": "€ 1,79",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Salumi",
            "blueprint": {
            "top": 73.16080808639526,
            "left": 35.23176593780518,
            "width": 29.436204648017885,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_WueDa5r_RnW6OQF.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm62723341",
            "field1": "Galbani",
            "field2": "galbanetto",
            "field3": "",
            "field4": "€ 1,99",
            "description": "Galbani galbanetto € 1,99",
            "grammage": null,
            "price": "1.39",
            "price_label": "€ 1,39",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Salumi",
            "blueprint": {
            "top": 73.16080808639526,
            "left": 64.66797058582306,
            "width": 30.319009804725646,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_fDrsxKX_dFiefPq.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            },
            {
            "type": "play",
            "title": "",
            "data": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/video/Galbanetto.mp4"
            }
            ]
            }
            ]
            },
            {
            "number": 7,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_7_c0t3i5F.jpg",
            "products": [
            {
            "item_id": "cstm99826063",
            "field1": "Kimbo",
            "field2": "caffè aroma italiano",
            "field3": "x2 500 g",
            "field4": "€ 4,99",
            "description": "Kimbo caffè aroma italiano x2 500 g € 4,99",
            "grammage": 500,
            "price": "2.99",
            "price_label": "€ 2,99",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Dispensa",
            "blueprint": {
            "top": 10.487194061279295,
            "left": 4.51171875,
            "width": 30.319009804725646,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_IeaAzSw_eX5Gs2s.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm47500284",
            "field1": "Sterilgarda",
            "field2": "latte scremato",
            "field3": "500 ml",
            "field4": "€ 0,65",
            "description": "Sterilgarda latte scremato 500 ml € 0,65",
            "grammage": 500,
            "price": "0.39",
            "price_label": "€ 0,39",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Self Service",
            "subcategory": "Latte",
            "blueprint": {
            "top": 10.487194061279295,
            "left": 34.830728554725646,
            "width": 29.837236523628235,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_gvZWDXL_wZZtttf.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm00835514",
            "field1": "Crema ",
            "field2": "pan di stelle",
            "field3": "480 g",
            "field4": "€ 4,99",
            "description": "Crema  pan di stelle 480 g € 4,99",
            "grammage": 480,
            "price": "2.99",
            "price_label": "€ 2,99",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Colazione",
            "blueprint": {
            "top": 10.6788201101674,
            "left": 64.67163494676711,
            "width": 29.209390955789537,
            "height": 20.359453839782777
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_xbDAmmT_XaO6VOR.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            },
            {
            "type": "specs",
            "title": "TABELLA NUTRIZIONALE per 100 g",
            "data": {
            "specifiche": "ENERGIA: 2201kJ - 527 kcal, GRASSI: 30,2 g, di cui SATURI: 5,3 g, CARBOIDRATI: 53,1 g, di cui ZUCCHERI: 51 g, PROTEINE: 8,3 g, SALE: 0,113 g",
            "img": [
            "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/images/cream-1.jpg"
            ]
            }
            },
            {
            "type": "info",
            "title": "",
            "data": {
            "titolo": "INGREDIENTI",
            "testo": "Crema alle nocciole e cacao (zucchero, olio di girasole, nocciole italiane 13,7%, cacao magro 9,8%, latte scremato in polvere, burro di cacao, emulsionante: lecitina di girasole, aroma vanillina), granella di biscotto Pan di Stelle 2% [farina di frumento, zucchero, olio di girasole, burro, latte fresco pastorizzato alta qualità, cacao, cioccolato (pasta di cacao, zucchero, burro di cacao, aroma naturale vaniglia, emulsionante: lecitina di soia), uova fresche, miele, nocciole, amido di frumento, agenti lievitanti (carbonato acido di sodio, carbonato acido d'ammonio), sale, aromi, albume d'uovo in polvere, amido]. Può contenere tracce di altra frutta a guscio.\nGli ingredienti della crema spalmabile Pan di Stelle possono provocare reazioni in persone allergiche o intolleranti. Conservare in luogo fresco ed asciutto lontano da fonti di calori.\nI PRODOTTI DI PAN DI STELLE, FATTI SEMPRE E SOLTANTO CON I MIGLIORI INGREDIENTI, SONO: SENZA COLORANTI, SENZA GRASSI IDROGENATI E SENZA ADDITIVI CONSERVANTI\n(Fonte: pandistelle.it)",
            "img": [
            "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/images/cream-1_GsHSWCz.jpg"
            ]
            }
            }
            ]
            },
            {
            "item_id": "cstm39805773",
            "field1": "Hero",
            "field2": "confetture assortite",
            "field3": "x4 100 g",
            "field4": "€ 1,19",
            "description": "Hero confetture assortite x4 100 g € 1,19",
            "grammage": 100,
            "price": "0.69",
            "price_label": "€ 0,69",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Dispensa",
            "blueprint": {
            "top": 31.14691972732544,
            "left": 5.3137880086898805,
            "width": 29.416671562194825,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_SlSVuwX_OotoQQW.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm72753896",
            "field1": "Nestlé ",
            "field2": "cereali go free ",
            "field3": "corn flakes senza glutine 375 g",
            "field4": "€ 1,89",
            "description": "Nestlé  cereali go free  corn flakes senza glutine 375 g € 1,89",
            "grammage": 375,
            "price": "1.49",
            "price_label": "€ 1,49",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Colazione",
            "blueprint": {
            "top": 31.14691972732544,
            "left": 34.730459570884705,
            "width": 29.837236523628235,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_jSsNer0_a2AVP5Y.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm14189523",
            "field1": "Misura",
            "field2": "fette biscottate assortite",
            "field3": "320 g",
            "field4": "€ 1,65",
            "description": "Misura fette biscottate assortite 320 g € 1,65",
            "grammage": null,
            "price": "0.99",
            "price_label": "€ 0,99",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Colazione",
            "blueprint": {
            "top": 31.14691972732544,
            "left": 64.56769609451294,
            "width": 29.617198514938362,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_rqOnjCj_L7DyYdf.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            },
            {
            "type": "play",
            "title": "",
            "data": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/video/MISURA_maggio_2020.mp4"
            }
            ]
            },
            {
            "item_id": "cstm01188923",
            "field1": "Santangelo",
            "field2": "croissant assortite",
            "field3": "x6 330 g",
            "field4": "€ 2,99",
            "description": "Santangelo croissant assortite x6 330 g € 2,99",
            "grammage": 330,
            "price": "1.99",
            "price_label": "€ 1,99",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Colazione",
            "blueprint": {
            "top": 52.067058086395264,
            "left": 5.313782501220703,
            "width": 29.617198514938355,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_Pva75BL_dcs36E1.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm02005826",
            "field1": "Migross",
            "field2": "plumcake",
            "field3": "x10 350 g",
            "field4": "€ 1,39",
            "description": "Migross plumcake x10 350 g € 1,39",
            "grammage": 250,
            "price": "0.97",
            "price_label": "€ 0,97",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Snack Dolci",
            "blueprint": {
            "top": 52.067058086395264,
            "left": 34.93098101615906,
            "width": 29.636709570884705,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_xxaky9m_2Oz0QNU.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm87299232",
            "field1": "Elah",
            "field2": "preparato per dessert",
            "field3": "assortiti 80 g",
            "field4": "€ 0,99",
            "description": "Elah preparato per dessert assortiti 80 g € 0,99",
            "grammage": 80,
            "price": "0.59",
            "price_label": "€ 0,59",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Dispensa",
            "blueprint": {
            "top": 52.067058086395264,
            "left": 64.56769058704376,
            "width": 30.419278788566597,
            "height": 20.746526718139652
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_bnJnu6K_iXTxl9j.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            },
            {
            "type": "world",
            "title": "",
            "data": "https://elah-dufour.it/it/linee/ELAH/"
            }
            ]
            },
            {
            "item_id": "cstm07948889",
            "field1": "Miscela caffè",
            "field2": "biologiche certificate UTZ",
            "field3": "100% arabica dell'Honduras - compatibili Nespresso",
            "field4": "",
            "description": "Miscela caffè biologiche certificate UTZ 100% arabica dell'Honduras - compatibili Nespresso",
            "grammage": null,
            "price": "2.19",
            "price_label": "€ 2,19",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Dispensa",
            "blueprint": {
            "top": 73.33441972732544,
            "left": 5.614561915397644,
            "width": 22.39844851493835,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_Qw83k7e_KEzEVk6.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm63268152",
            "field1": "Biologiche certificate UTZ",
            "field2": "100% arabica dell'Honduras",
            "field3": "capsule - compatibili Nespresso",
            "field4": "",
            "description": "Biologiche certificate UTZ 100% arabica dell'Honduras capsule - compatibili Nespresso",
            "grammage": null,
            "price": "1.99",
            "price_label": "€ 1,99",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Dispensa",
            "blueprint": {
            "top": 73.33441972732544,
            "left": 28.013010430336006,
            "width": 32.84504718780518,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_ztGfzcE_AiugqHf.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            },
            {
            "item_id": "cstm65552266",
            "field1": "Caffè biologiche certificate UTZ",
            "field2": "100% arabica dell'Honduras",
            "field3": "compatibili Dolce gusto",
            "field4": "",
            "description": "Caffè biologiche certificate UTZ 100% arabica dell'Honduras compatibili Dolce gusto",
            "grammage": null,
            "price": "0.95",
            "price_label": "€ 0,95",
            "equivalence": 1,
            "quantity_step": 1,
            "grocery_label": "pz.",
            "varieties": [],
            "price_for_kg": null,
            "available_pieces": null,
            "max_purchasable_pieces": null,
            "points": "",
            "fidelity_product": false,
            "focus": false,
            "pam": false,
            "three_for_two": false,
            "one_and_one_gratis": false,
            "underpriced_product": false,
            "category": "Alimentari",
            "subcategory": "Dispensa",
            "blueprint": {
            "top": 73.35069179534912,
            "left": 58.993482851982115,
            "width": 35.95312132835388,
            "height": 25.78125
            },
            "images": [
            {
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/products/cropped_image_8nhbj59_ua5oVFR.png",
            "cropped": true
            }
            ],
            "markers": [
            {
            "type": "plus",
            "title": null,
            "data": ""
            }
            ]
            }
            ]
            },
            {
            "number": 8,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_8_H3ajz58.jpg",
            "products": []
            },
            {
            "number": 9,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_9_5WoE8Mc.jpg",
            "products": []
            },
            {
            "number": 10,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_10_Uae1mLP.jpg",
            "products": []
            },
            {
            "number": 11,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_11_kuh1xUQ.jpg",
            "products": []
            },
            {
            "number": 12,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_12_6cKcpRh.jpg",
            "products": []
            },
            {
            "number": 13,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_13_PByToVY.jpg",
            "products": []
            },
            {
            "number": 14,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_14_sO4FLOF.jpg",
            "products": []
            },
            {
            "number": 15,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_15_qUNwC20.jpg",
            "products": []
            },
            {
            "number": 16,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/page_16_MxTiia4.jpg",
            "products": []
            },
            {
            "number": 17,
            "image_file": "https://interattivo.s3.amazonaws.com/Da8rP4x8ak/pages/Fine_pagina_Migross_h3iobFB.png",
            "products": []
            }
            ]
            }
    }

}

const lefletSwitch = () => {
    return leaflets.migross;
}

export const serverResponse = lefletSwitch(); 